import type { PriceBreakdown as PB } from '../generated/checkout.graphql';
import * as BreakdownItem from './BreakdownItem';

import { take } from '../util/takePayload';

export interface PriceBreakdown {
  itemsBreakdown?: BreakdownItem.BreakdownItem[];
  itemsTotal?: number;
  orderTotal?: number;
  totalBreakdown?: BreakdownItem.BreakdownItem[];
}

export const getNew = (): PriceBreakdown => ({});

export const fromGql = (gqlItem?: PB): PriceBreakdown =>
  (gqlItem && {
    ...(take(gqlItem, 'itemsTotal', 'orderTotal') as PriceBreakdown),
    itemsBreakdown: gqlItem.itemsBreakdown?.map(BreakdownItem.fromGql) || [],
    totalBreakdown: gqlItem.totalBreakdown?.map(BreakdownItem.fromGql) || [],
  }) ||
  ({} as PriceBreakdown);
